import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "dark" | "light";
};
export function SectionHeading({
  kicker,
  title,
  intro,
  tone = "dark"
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-62" data-mp="3k06xfwc3ovzb">
      {kicker && <p className={`text-sm font-extrabold uppercase tracking-wide ${isDark ? "text-brand" : "text-[#0A7FBF]"}`} data-id="element-63" data-mp="3k0f6te90lj5r">
          {kicker}
        </p>}
      <h2 className={`mt-3 text-balance font-display text-[30px] font-extrabold leading-[1.12] sm:text-5xl ${isDark ? "text-white" : "text-navy"}`} data-id="element-64" data-mp="gjq2lywwmlj9">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-lg leading-relaxed sm:text-xl ${isDark ? "text-white/75" : "text-navy/75"}`} data-id="element-65" data-mp="6s2fubbalso4">
          {intro}
        </div>}
    </div>;
}